// Board cards as GET /api/companyboarditems/:slug sends them, made ready to show. Shared by the deck
// (CompanyBoard.vue) and the Inbox panel (InboxPanel.vue), whose cards are board cards too.

// "Oct 8" (or "Oct 8, 2025" outside this year), and whether the date has passed. monthShort: the store's monthShortStrings.
export function cardDateInfo(date: string, monthShort: string[]) {
    const [year, month, day] = date.split('-').map((p: string) => parseInt(p));
    let display = `${monthShort[month]} ${day}`;
    if(year != new Date().getFullYear()) {
        display += ', ' + year;
    }
    // Overdue the day after it's due, as on meeting boards (Meetings.vue isItemOverdue): a card due today isn't late yet
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return { DateDisplay: display, Overdue: date < today };
}

// In place: its due date (DateDisplay, Overdue), tags parsed, and checklist progress. Cards checked off or in
// lastColumn (the done column) aren't overdue.
export function prepareCard(item: any, lastColumn: string | null, monthShort: string[]) {
    if(item.Date) {
        item.Date = new Date(item.Date).toISOString().split('T')[0];
        Object.assign(item, cardDateInfo(item.Date, monthShort));
        if(item.Checked || item.Column == lastColumn) {
            item.Overdue = false;
        }
    }
    if(item.TagsJSON) {
        item.TagsJSON = JSON.parse(item.TagsJSON);
    } else {
        item.TagsJSON = [];
    }
    item.TotalChecklistItems = 0;
    item.CheckedChecklistItems = 0;
    if(item.ChecklistJSON) {
        try {
            for(const list of JSON.parse(item.ChecklistJSON)) {
                for(const listItem of list.items || []) {
                    item.TotalChecklistItems++;
                    if(listItem.checked) {
                        item.CheckedChecklistItems++;
                    }
                }
            }
        } catch(e) {
            console.log(e);
        }
    }
    return item;
}
